// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"Modal_modalContainer__28A7L","modal":"Modal_modal__1vwov","modal_header":"Modal_modal_header__yX-CH","title":"Modal_title__1gczl","close":"Modal_close__2EfR5"};